import { createSlice } from "@reduxjs/toolkit";

export const ProjectFollowersSlice = createSlice({
    name : 'project_followers',
    initialState : {
        followersCollection : [],
        allUserGroupFollowers: []
    },
    reducers : {
        updateFollowersCollection: (state, action) => {
            state.followersCollection = action.payload;
        },
        updateAllUserGroupFollowers: (state, action) => {
            state.allUserGroupFollowers = action.payload;
        }
    }
});

export const { updateFollowersCollection } = ProjectFollowersSlice.actions
export const { updateAllUserGroupFollowers } = ProjectFollowersSlice.actions

export default ProjectFollowersSlice.reducer